import React from 'react';
import { InputText } from 'primereact/inputtext';
import { FormField } from '../../FormField/FormField';
import { ROUTINE_TYPES } from '../../../types/Fisiofit/routine';
import { getRoutineDisplayName } from '../utils/form';
import { RoutineFormFieldProps } from '../types';

type RoutineNameFieldProps = RoutineFormFieldProps & {
  isCreating: boolean;
  isEditing: boolean;
  isNextRoutine: boolean;
};

export const RoutineNameField = ({
  form,
  setFormFields,
  validationErrors,
  isCreating,
  isEditing,
  isNextRoutine,
}: RoutineNameFieldProps) => {
  return (
    <FormField
      labelTitle='Nombre de la rutina'
      elementId='routine-name'
      fullWidth
      error={validationErrors?.name}
      required={(isCreating || isEditing) && form?.routineType === ROUTINE_TYPES.TEMPLATE}
    >
      {(isCreating || isEditing) && form?.routineType === ROUTINE_TYPES.TEMPLATE ? (
        <InputText
          id='routine-name'
          invalid={!!validationErrors?.name}
          placeholder={`Nombre de la plantilla`}
          value={form?.name ?? ''}
          onChange={(e) => setFormFields({ name: e.target.value })}
        />
      ) : (
        <p>{getRoutineDisplayName(form?.name, isNextRoutine)}</p>
      )}
    </FormField>
  );
};
